export const ChatbotConfig = {
  api: {
    baseUrl: "/api/chat",
    timeout: 60000,
  },

  ester: {
    welcomeMessage: "Hi! I'm Ester, your ClarityAI assistant. How can I help you today?",

    ui: {
      primaryColor: "#1890ff",
      assistantAvatarBg: "#1890ff",
      position: {
        bottom: "100px",
        right: "20px"
      }
    }
  }
};

export default ChatbotConfig;
